import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { UserPermissionReport } from 'src/app/interfaces/apiresponses'; 
import { DatePipe } from '@angular/common';
import { TableUtil } from 'src/app/shared/utils/table.util';

@Component({
  selector: 'app-support-user-permission-audit-report',
  templateUrl: './support-user-permission-audit-report.component.html',
  styleUrls: ['./support-user-permission-audit-report.component.scss'],
  providers: [DatePipe]
})
export class SupportUserPermissionAuditReportComponent {
  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef){

  }

  // Alert buttons
  bAlert = false 
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  nItems: number = 10 

  closeAlert(event: any){

  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading;
    this.alertBodyText = body;
    this.bShowSecondAlertButton = showSecondButton;
    this.alertSecondButtonText = secondButtonText;
    this.alertCloseButtonText = closeButtonText;
    this.alertBoxData = data;
    this.bAlert = true;
  
    // Disable scrolling
    document.body.style.overflow = 'hidden';
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state
    if (event.data.action === 1){
    }
  } 

  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);  

  columns = [
    {
      key: 'cif',
      label: 'CIF',
      filter: true
    },
    {
      key: 'companyName',
      label: 'Company',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'userEmail',
      label: 'Customer',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'makerEmail',
      label: 'Maker',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'checkerEmail',
      label: 'Checker',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'active',
      label: 'Active',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'createdOn',
      label: 'Request On',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'matrixName',
      label: 'Permission Type',
      filter: false
    },
    {
      key: 'enable',
      label: 'Permission State',
      filter: false
    },
    {
      key: 'threshold',
      label: 'Threshold',
      filter: false
    },
    {
      key: 'isMaker',
      label: 'Maker/Checker',
      filter: false
    },
    {
      key: 'isCIFLevelAuthority',
      label: 'CIF/Account Level',
      filter: false
    },
   
    {
      key: 'accountNumber',
      label: 'Account No',
      filter: false
    },
    {
      key: 'isDecisionTaken',
      label: 'Is Decision Taken',
      filter: false
    },
    {
      key: 'decisionOn',
      label: 'Decision On',
      filter: false
    },
    {
      key: 'isApproved',
      label: 'Is Approved',
      filter: false
    },
    {
      key: 'disapprovalReason',
      label: 'Disapproval Reason',
      filter: false
    }
  ];

  reportData: IItem[] = []
  bShowDownloadButton: boolean = false
  selectedItems = [2, 3];

  getDateString(dateValue: Date){
    return this.datePipe.transform(dateValue,"yyyy-MM-dd")
  }

  getDateDisplayString(dateValue: Date){
    var displayDate = this.datePipe.transform(dateValue,"dd-MM-yyyy")

    if (displayDate === '01-01-0001')
      return ''
    else
      return displayDate
  }

  getActiveState(item: any){
    if (item)
      return 'Active'
    else
      return 'Inactive'
  }

  getEnabledState(item: any){
    if (item)
      return 'Enabled'
    else
      return 'Disabled'
  }

  getMakerState(item: any){
    if (item)
      return 'Maker'
    else
      return 'Checker'
  }

  getCIFAccountState(item: any){
    if (item)
      return 'CIF Level Authority'
    else
      return 'Account Level Authority'
  }

  getThresholdState(item: any){
    if (item == -1)
      return 'Unlimited'
    else if (item == 0)
      return 'Not Applicable'
    else
      return item
  }

  getDecisionState(item: any){
    if (item)
      return 'Yes'
    else
      return 'No'
  }

  getApprovalState(item: any){
    if (item.isDecisionTaken) {
      if (item.isApproved)
        return 'Approved'
      else
        return 'Rejected'
    } else {
      return 'Decision Pending'
    }
    
  }

  // Search Form
  searchReportType: string = ''
  
  cifSearchForm = new FormGroup({
    CompanyCIF : new FormControl("",Validators.pattern(/^\d*$/)),
    searchReportTypeControl: new FormControl(this.searchReportType),
  })

  get searchReportTypeControl() {return this.cifSearchForm.get('searchReportTypeControl')}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  onStartDateChane(item: any){
    this.bShowDownloadButton = false
    this.startDate = item
    this.reportData = []
  }

  onEndDateChane(item: any){
    this.bShowDownloadButton = false
    this.endDate = item
    this.reportData = []
  }

  generateReport(){
  const CompanyCIF = this.cifSearchForm.get('CompanyCIF')?.value?.trim() || null;

  const startDateString = this.getDateString(this.startDate) || null;
  const endDateString = this.getDateString(this.endDate) || null;

  if (!CompanyCIF && (!startDateString || !endDateString)) {
    this.showAlertBox('Missing Criteria', 'Please provide either CIF or a valid date range.', 'Close');
    return;
  }


    this.restApi.getUserPermissionReport(CompanyCIF, startDateString, endDateString).subscribe({
      next: (v: UserPermissionReport) => {
        this.bShowDownloadButton = true;
        this.reportData = v.matrices.map((item, Reference) => {
          const _selected = this.selectedItems.includes(Reference);
          return {
            ...item,
            _selected
          };
        });
      },
      error: (e) => {
        this.showAlertBox('Error', 'Failed to generate report.', 'Close');
      }
    });
  }

  downloadReport(){
    const columns = [
      { key: 'cif', label: 'CIF' },
      { key: 'companyName', label: 'Company' },
      { key: 'userEmail', label: 'Customer' },
      { key: 'makerEmail', label: 'Maker' },
      { key: 'checkerEmail', label: 'Checker' },
      { key: 'active', label: 'Active' },
      { key: 'createdOn', label: 'Request On' },
      { key: 'matrixName', label: 'Permission Type' },
      { key: 'enable', label: 'Permission State' },
      { key: 'threshold', label: 'Threshold' },
      { key: 'isMaker', label: 'Maker/Checker' },
      { key: 'isCIFLevelAuthority', label: 'CIF/Account Level' },
      { key: 'accountNumber', label: 'Account No' },
      { key: 'isDecisionTaken', label: 'Is Decision Taken' },
      { key: 'decisionOn', label: 'Decision On' },
      { key: 'isApproved', label: 'Is Approved' },
      { key: 'disapprovalReason', label: 'Disapproval Reason' }
    ]; 
    
    const formattedData = this.reportData.map(item => {
      const newItem: any = {};
      columns.forEach(col => {
        let value = item[col.key];

        switch (col.key) {
          case 'createdOn':
          case 'decisionOn':
            newItem[col.label] = this.getDateDisplayString(value);
            break;
          case 'enable':
            newItem[col.label] = this.getEnabledState(value);
            break;
          case 'active':
            newItem[col.label] = this.getActiveState(value);
            break;            
          case 'isMaker':
            newItem[col.label] = this.getMakerState(value);
            break;
          case 'isCIFLevelAuthority':
            newItem[col.label] = this.getCIFAccountState(value);
            break;
          case 'threshold':
            newItem[col.label] = this.getThresholdState(value);
            break;
          case 'isDecisionTaken':
          case 'isApproved':
            newItem[col.label] = this.getDecisionState(value);
            break;
          default:
            newItem[col.label] = value;
        }
      });
      return newItem;
    });



    if (TableUtil.exportArrayToExcel(formattedData, 'UserPermissionsAuditReport')) 
      this.showAlertBox('Downloaded', 'The report is downloaded. Please look for the report in your browser download section.')
    else
      this.showAlertBox('Sorry', 'Unable to download the report. Please contact technical support.')
  }
}
